import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getVirtualCards } from '../../api/api';

import cardBgImg from '../../assets/img/logo/card_bg-cardplot.png';
import cardBgImg1 from '../../assets/img/logo/card_bg_logo.png';
import visaCardLogo from '../../assets/img/logo/visa-card-logo.png';
import masterCardLogo from '../../assets/img/logo/mastercard-logo.png';
import verveCardLogo from '../../assets/img/logo/verve-card-logo.png';
import masterCardBgImg from '../../assets/img/logo/masterCard-watermark.png';
import { MdOutlineAddCard, MdFormatListBulleted } from 'react-icons/md';
import CardItem from './CardItem'; 
import NoCardPage from './NoCardPage';
import Loader from '../Loader/Loader';

const CardsPage = ({ userDetails }) => { 
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchCards = useCallback(async () => {
    try {
      setLoading(true);
      setError(false);
      const res = await getVirtualCards();
      console.log("Fetched cards:", res.data);
      
      let cardsArray = [];
      if (Array.isArray(res.data)) {
        cardsArray = res.data;
      } else if (Array.isArray(res.data?.data)) {
        cardsArray = res.data.data;
      } else if (Array.isArray(res.data?.data?.data)) {
        cardsArray = res.data.data.data;
      } else if (Array.isArray(res.data?.data?.data?.data)) {
        cardsArray = res.data.data.data.data;
      }
      setCards(cardsArray);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (userDetails?.has_approved_kyc && userDetails?.kyc_tier_two_profile?.status == 'approved') {
      fetchCards();
    } else {
      setLoading(false);
    }
  }, [fetchCards, userDetails?.has_approved_kyc]);

  const hasAnyPendingCard = cards.some((card) => {
    const status = card?.status || card?.card_status || card?.state;
    return String(status || "").toLowerCase() === "pending";
  });
  
  // Filter out pending cards for display
  const activeCards = cards.filter((card) => {
    const status = card?.status || card?.card_status || card?.state;
    return String(status || "").toLowerCase() !== "pending";
  });

  if (!userDetails?.has_approved_kyc) {
    return (
      <section className='create__card__page cardList__page'>
        <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: "60vh" }}>
            <h4 className="mb-3">KYC Verification Required</h4>
            <p className="text-muted mb-4" style={{ maxWidth: "400px", margin: "0 auto" }}>You need to complete your identity verification (KYC) to access and create virtual cards.</p>
            <Link to="/user/settings" state={{ activeTab: 'compliance' }} className="btn d-flex align-items-center justify-content-center gap-2 shadow-sm mx-auto mt-3" style={{ width: '220px', backgroundColor: '#0A95FF', color: '#fff', borderRadius: '12px', padding: '12px 0', fontWeight: '500' }}>
                Verify KYC Now
            </Link>
        </div>
      </section>
    );
  }

  if (!userDetails?.kyc_tier_two_profile || userDetails?.kyc_tier_two_profile?.status != 'approved') {
    return <NoCardPage completeKyc={true}/>;
  }

  if ((!loading && !error && (!cards || cards.length === 0)) || !userDetails?.virtual_card_supported_in_user_country) {
    return <NoCardPage cardIssuingAvailable={userDetails?.virtual_card_supported_in_user_country}/>;
  }


  return (
    <section className='create__card__page cardList__page'>
        <section className="create-card_section cardList__section">
            <div className="section-cont container py-5">
               {userDetails?.virtual_card_supported_in_user_country && !loading && (
                  hasAnyPendingCard ? (
                    <div className="mb-5 cards-content-wrap">
                      <div
                        className="alert alert-warning mb-0"
                        role="alert"
                        aria-live="polite"
                        style={{ borderRadius: "12px" }}
                      >
                        <strong>Card creation in progress.</strong>
                        <div className="mt-1">
                          Your virtual card is being processed. Please wait until approval is complete.
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="mb-5 d-flex flex-wrap   gap-3">
                      {/* <div className="mb-5 d-flex flex-wrap justify-content-center justify-content-lg-start  gap-3"> making the button be at the middle on mobile */}
                      <Link to='step1' className='btn d-flex align-items-center justify-content-center gap-2 shadow-sm' style={{ width: '220px', backgroundColor: '#0A95FF', color: '#fff', borderRadius: '12px', padding: '12px 0', fontWeight: '500' }}>
                          <MdOutlineAddCard size={22} />
                          <span>Create New Card</span>
                      </Link>
                    </div>
                  )
                )}

                {/* Card List */}
                {loading ? (
                  <div className="d-flex justify-content-center w-100 py-5 mt-5">
                    <Loader text="Loading virtual cards..." />
                  </div>
                ) : error ? (
                  <div className="text-center text-danger py-5">Failed to load virtual cards.</div>
                ) : activeCards && activeCards.length > 0 && userDetails?.virtual_card_supported_in_user_country ? (
                  <div className="card-grid-container">
                    {activeCards.map((card) => {
                      const mappedCard = {
                        id: card.id,
                        cardName: card.card_name || "Visa Card",
                        cardSlug: card.virtual_card_brand?.network || "visa",
                        cardholderName: card.card_holder?.full_name || userDetails?.bank_account?.[0]?.account_name || "EZEKIEL EGBETAMAH",
                        nickname: card.nickname || "nickname",
                        cardNumber: card.masked_pan?.replace(/\*/g, '0') || "0000000000000000",
                        expiryDate: (card.expiry_month && card.expiry_year) ? `${card.expiry_month}/${card.expiry_year}` : "04/27",
                        cvv: "***",
                        cardLogo: (card.virtual_card_brand?.network?.toLowerCase() === 'mastercard') ? masterCardLogo : visaCardLogo,
                        backgroundColor: "#1A83E2",
                        ...card
                      };
                      return <CardItem key={card.id} card={mappedCard} />;
                    })}
                  </div>
                ) : null}
            </div>
        </section>
    </section>
)
}

export default CardsPage
